module.exports = __webpack_public_path__ + "img/combat-robotics.64e7ce1e.png";